// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});



//////////////////
// WEBPACK FOOTER
// D:/ENI Project/Trunk/AngularSourceCode/ENI.BalanceBenefits.WebPortal/~/core-js/modules/es6.math.trunc.js
// module id = ../../../../core-js/modules/es6.math.trunc.js
// module chunks = 2